import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';

const generateTranslationKey = (value, prefix) => {
    const trimmedValue = (value && value.trim()) || '';
    if (!trimmedValue) {
        return '';
    }
    const p = prefix ? `${prefix}.` : '';
    return `${p}${trimmedValue
        .split(' ')
        .filter((x) => x)
        .map((x) => x.toLowerCase())
        .join('.')}`;
};
class TranslationKeyGeneratorPipe {
    transform(value, prefix) {
        return generateTranslationKey(value, prefix);
    }
}
TranslationKeyGeneratorPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TranslationKeyGeneratorPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipe, name: "translationKeyGenerator" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'translationKeyGenerator',
                }]
        }] });

class TranslationKeyGeneratorPipeModule {
}
TranslationKeyGeneratorPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TranslationKeyGeneratorPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipeModule, declarations: [TranslationKeyGeneratorPipe], exports: [TranslationKeyGeneratorPipe] });
TranslationKeyGeneratorPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipeModule, providers: [TranslationKeyGeneratorPipe] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: TranslationKeyGeneratorPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TranslationKeyGeneratorPipe],
                    imports: [],
                    exports: [TranslationKeyGeneratorPipe],
                    providers: [TranslationKeyGeneratorPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TranslationKeyGeneratorPipe, TranslationKeyGeneratorPipeModule, generateTranslationKey };
